import React from 'react';
import './CourseCard.css';

export default function CourseCardTag() {
    return (
        <div className='card__box'>
            <div className='card__box_tag'>
                <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.3308 7.61447H17.4496M6.87467 2.0001V3.8317M6.87467 3.8317L17.4994 3.8315M6.87467 3.8317C5.11425 3.8317 3.68732 5.28333 3.68741 7.07419L3.6879 17.8826C3.68798 19.6734 5.11501 21.125 6.87531 21.125H17.5C19.2604 21.125 20.6875 19.6732 20.6874 17.8823L20.6869 7.07389C20.6868 5.28314 19.2597 3.8315 17.4994 3.8315M17.4994 2V3.8315M10.0629 17.342V10.8569L7.93792 12.4782M15.9064 17.342V10.8569L13.7815 12.4782"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </i>
                <span class='text-nowrap'>старт в декабре</span>
            </div>
            <div className='card__box_tag basis-[47%] shrink-1'>
                <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.25 3H19.25M5.25 21H19.25M17.5 3V5.64723C17.5 6.33742 17.262 7.0065 16.8262 7.54167L13.9511 11.072C13.4422 11.6969 13.4543 12.5794 13.9801 13.1912L16.775 16.4423C17.2428 16.9865 17.5 17.6803 17.5 18.3979V21M7 3V5.64723C7 6.33742 7.23798 7.0065 7.67383 7.54167L10.5489 11.072C11.0578 11.6969 11.0457 12.5794 10.5199 13.1912L7.72505 16.4423C7.25724 16.9865 7 17.6803 7 18.3979V21"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </i>
                <span class='text-nowrap'>6 месяцев</span>
            </div>
            <div className='card__box_tag basis-[47%]'>
                <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1055 8.83333H9.3555M15.8752 14.3867L20.5252 16.6771C21.0072 16.9705 21.513 16.7976 21.5 16.1856L21.4674 8.09104C21.4262 7.42667 21.0341 7.24539 20.4568 7.55242L15.8621 9.64057M5.25 18.5H13.6055C14.8481 18.5 15.8555 17.5051 15.8555 16.2778L15.8752 13.4275L15.8555 7.72222C15.8555 6.49492 14.8481 5.5 13.6055 5.5H5.25C4.00736 5.5 3 6.49492 3 7.72222V16.2778C3 17.5051 4.00736 18.5 5.25 18.5Z"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </i>
                <span class='text-nowrap'>онлайн видеоуроки</span>
            </div>
            <div className='card__box_tag basis-[47%]'>
                <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1395 20.4866C13.5308 19.4663 17.3708 18.0379 21.6004 20.4866V5.18226M2.40039 4.904V20.4866C3.79169 19.4663 7.63169 18.0379 11.8613 20.4866V5.46052M2.40039 4.86475C3.79169 3.84446 7.63169 2.41605 11.8613 4.86475M12.1395 4.86475C13.5308 3.84446 17.3708 2.41605 21.6004 4.86475"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </i>
                <span class='text-nowrap'>дз и пробники</span>
            </div>
        </div>
    )
}
